var map = {
	"./Dry-Dock-Highway-AL-BAHRAIN/1.webp": 4837,
	"./EL-Salam-International-Hospital/1.webp": 2959,
	"./HSR-High-Speed-Rail/1.webp": 9572,
	"./Mansoura-Bridge/1.webp": 2118,
	"./Murcia-Almeria-High-Speed-Mediterranean-Corridor-Platform/1.webp": 6841,
	"./Warraq-Nile-Bridge/1.webp": 7124
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1588;